export const interiorView06ImageOptions = {
	angle:"InteriorView06",
	staticOptions:{
		PortAftCabinOptions:1,
		StarboardAftCabinOptions:1,
		Floorboard:1,
		Worktop:1,
		StarboardAftCabin:1,
		FabricSaloon:1,
		Mast:1,
		TableBox:1,
		Pouffes:1,
		FabricCabins:1,
	},
	mattes:[
		{
			option:"Veneer",
			dependency:null
		},
		{
			option:"CupboardsOwnersCabin",
			dependency:"Veneer"
		},
		{
			option:"FabricCabins",
			dependency:null
		},
	],
	overlays:[
	]
};



// WEBPACK FOOTER //
// ./src/X46MK2/views/InteriorView06.js